import ResumeTypes from './types'
import { ManagersResumeState } from './state';

export const fetchResumeStart = () => ({
    type: ResumeTypes.FETCH_START
});

export const fetchResumeSuccess = (data: ManagersResumeState) => ({
    type: ResumeTypes.FETCH_SUCCESS,
    payload: data
});

export const fetchResumeFailure = () => ({
    type: ResumeTypes.FETCH_FAILURE
});